<template>
  <room-type-form />
</template>

<script>
import RoomTypeForm from '@/components/forms/RoomTypeForm'
export default {
  components: {
    RoomTypeForm
  }
}
</script>
